module.exports = __webpack_public_path__ + "img/dzg.dd04f1c9.png";